import { ThemeProvider } from "next-themes";
import { createContext, useContext, useState, type ComponentProps } from "react";

type EmbedTheme = "light" | "dark";
const EmbedThemeContext = createContext<{
  theme: EmbedTheme | undefined;
  setTheme: (theme: EmbedTheme) => void;
}>({ theme: undefined, setTheme: () => undefined });

export const useMarketingEmbedTheme = () => useContext(EmbedThemeContext);

export const MarketingThemeProvider: React.FC<
  ComponentProps<typeof ThemeProvider> & { embed: boolean }
> = ({ embed, children, ...props }) => {
  const [theme, setTheme] = useState<EmbedTheme>();
  return (
    <EmbedThemeContext.Provider value={{ theme, setTheme }}>
      <ThemeProvider
        {...props}
        // Different parent pages may request opposite themes on the same frontend origin.
        // Forced themes stay in this frame instead of broadcasting through localStorage.
        forcedTheme={embed ? theme ?? "light" : props.forcedTheme}
        enableColorScheme={embed ? false : props.enableColorScheme}
      >
        {children}
      </ThemeProvider>
    </EmbedThemeContext.Provider>
  );
};
